import React from 'react';

const NotFound = () => {
    return (
        
            <div className='h-screen flex justify-center my-10'>
                <img width={600} height={500} src="https://drudesk.com/sites/default/files/2018-02/404-error-page-not-found.jpg" alt="notfound" />
            </div>
        
    );
};

export default NotFound;